<template>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
            <div class="customer-label-group mb-3">
                <div class="historyheader text-center">
                    Voter Card Details
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-8 col-md-8 col-12 mx-auto">
            <div class="election-card-front-outer">
                <div class="election-card-header-padding">
                    <div class="election-card-header">
                        <img @dragstart.prevent @contextmenu.prevent
                            src="/assets/images/voter-card-images/header-voter-img.png" class="" alt
                            style="height: 45px; width: 100%;" />
                    </div>
                    <div class="election-card-detail-inner">
                        <div class="election-name text-uppercase "
                            v-if="props.tenantvoter.aa177">
                            {{
                                props.tenantvoter.aa177
                                    ?
                                    props.tenantvoter.aa177
                                    : "N/A"
                            }}
                        </div>
                        <div>
                            <span class="election-card-number-header text-capitalize">Name:
                            </span><span class="election-name text-capitalize">{{
                                props.tenantvoter.aa181
                                    ?
                                    props.tenantvoter.aa181
                                    : "N/A"
                            }}</span>
                        </div>
                        <div>
                            <span class="election-card-number-header text-capitalize">Area:
                            </span><span class="election-name text-capitalize">{{
                                props.tenantvoter.aa186
                                    ?
                                    props.tenantvoter.aa186
                                    : "N/A"
                            }}</span>
                        </div>
                        <div>
                            <span class="election-card-number-header text-capitalize">Polling
                                Station: </span><span class="election-name text-capitalize">{{
                                    props.tenantvoter.aa182
                                        ?
                                        props.tenantvoter.aa182
                                        : "N/A"
                                }}</span>
                        </div>

                    </div>
                    <div class="election-card-footer">
                        <img @dragstart.prevent @contextmenu.prevent
                            src="/assets/images/voter-card-images/footer-voter-img.png" class="" alt
                            style="width: 80%; opacity: 0.7;" />
                    </div>
                </div>
            </div>
            <div class="election-card-front-outer">
                <div class="election-card-header-padding">
                    <div class="election-card-header">
                        <img @dragstart.prevent @contextmenu.prevent
                            src="/assets/images/voter-card-images/header-voter-img.png" class="" alt
                            style="height: 45px; width: 100%;" />
                    </div>
                    <div class="election-card-detail-inner">
                        <div>
                            <span class="election-card-number-header text-capitalize">Part
                                Number: </span><span class="election-name text-capitalize">{{
                                    props.tenantvoter.aa180
                                        ?
                                        props.tenantvoter.aa180
                                        : "N/A"
                                }}</span>
                        </div>
                        <div>
                            <span class="election-card-number-header text-capitalize">Assembly
                                Constituency: </span><span class="election-name text-capitalize">{{
                                    props.tenantvoter.aa189
                                        ?
                                        props.tenantvoter.aa189
                                        : "N/A"
                                }}</span>
                        </div>
                        <div>
                            <span class="election-card-number-header text-capitalize">Assembly
                                Constituency
                                Number: </span><span class="election-name text-capitalize">{{
                                    props.tenantvoter.aa190
                                        ?
                                        props.tenantvoter.aa190
                                        : "N/A"
                                }}</span>
                        </div>
                        <div>
                            <span class="election-card-number-header text-capitalize">Parliamentary
                                Constituency: </span><span class="election-name text-capitalize">{{
                                    props.tenantvoter.aa191
                                        ?
                                        props.tenantvoter.aa191
                                        : "N/A"
                                }}</span>
                        </div>
                    </div>
                    <div class="election-card-footer">
                        <img @dragstart.prevent @contextmenu.prevent
                            src="/assets/images/voter-card-images/footer-voter-img.png" class="" alt
                            style="width: 80%; opacity: 0.7;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    id: {
        type: [String, Number],
        required: true,
    },
    tenantvoter: Object,
});
</script>
<style scoped>
.agreement-sub-tab-outer .historyheader {
    color: #0f0f0f;
    font-size: 18px;
    font-family: "OpenSans-Regular";
    line-height: 30px;
    text-align: center;
    margin-bottom: 15px;
}
</style>